export default __webpack_public_path__ + "static/media/api-analitics.e2a1f93c.svg";